var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { observable } from "mobx";
import React, { useContext } from "react";
import { useCreateResizeQueryWithRef } from "../../hooks/useCreateResizeQueryWithRef.hook";
import { generateUuid } from "../../utils/id.utils";
import { useAutoSyncWithInitializer } from "../../utils/mobx.utils";
export var createFormContext = function (options) {
    var s = observable({
        id: options.id || generateUuid(),
        get name() { return options.name || "Form-" + s.id; },
        get form() { return options.form; },
        get formRef() { return options.formRef; },
        get resizeQuery() { return options.resizeQuery; },
        get commonUnits() {
            var _a, _b, _c;
            return {
                gap: ((_a = options.resizeQuery) === null || _a === void 0 ? void 0 : _a.fromTablet) ? '1em' : '.5em',
                paddingX: ((_b = options.resizeQuery) === null || _b === void 0 ? void 0 : _b.fromTablet) ? '2em' : '1em',
                paddingY: ((_c = options.resizeQuery) === null || _c === void 0 ? void 0 : _c.fromTablet) ? '1.5em' : '1em',
            };
        },
        get disabled() { return options.disabled; },
        get onFocus() { return options.onFocus && (function () { return options.onFocus(options.form); }); },
        get onBlur() { return options.onBlur && (function () { return options.onBlur(options.form); }); },
        get onChange() { return options.onChange && (function () { return options.onChange(options.form); }); },
        get onSave() { return options.onSave && (function () { return options.onSave(options.form); }); },
        get onReset() { return options.onReset && (function () { return options.onReset(options.form); }); },
    });
    return s;
};
export var useCreateFormContextAndResizeQuery = function (p) {
    var _a = useCreateResizeQueryWithRef(), ref = _a.ref, query = _a.query;
    var s = useAutoSyncWithInitializer(function () { return (__assign(__assign({}, p), { get formRef() { return ref; },
        get resizeQuery() { return query; } })); }, p);
    return {
        context: createFormContext(s),
        ref: ref,
        query: query
    };
};
export var DefaultFormContextContent = createFormContext({});
export var FormContext = React.createContext(DefaultFormContextContent);
export var useFormContext = function () { return useContext(FormContext); };
